import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from '../../../../../common/react/utils/translations';
import { SvgIcon } from '../../../../../common/react/components/SvgIcon';

export const LadderLegend = ({ qualifiers, compLabel, isWinRatio }) => {
    return (
        <aside className="ladder-legend">
            <p className="ladder-legend__title">
                <SvgIcon icon="badge-premiership" className="icon" />
                {compLabel}
            </p>

            <dl>
                {/* top 8 */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.top`)} {qualifiers}:
                </dl>

                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.qualifyTo`)}
                </dd>

                {/* played */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.played`)}:
                </dl>
                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.legend.played`)}
                </dd>

                {/* points */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.points.short`)}:
                </dl>

                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.points`)}
                </dd>

                {/* win ratio */}
                {isWinRatio && (
                    <>
                        <dl className="ladder-legend__item ladder-legend__item--key">
                            {getTranslation(`label.ladder.winRatio.short`)}:
                        </dl>
                        <dd className="ladder-legend__item">
                            {getTranslation(`label.ladder.winRatio.long`)}
                        </dd>
                    </>
                )}

                {/* won */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.won.short`)}:
                </dl>
                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.won`)}
                </dd>

                {/* lost */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.lost.short`)}:
                </dl>

                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.lost`)}
                </dd>

                {/* drawn */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.drawn.short`)}:
                </dl>
                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.drawn`)}
                </dd>

                {/* points for */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.pointsFor.short`)}:
                </dl>
                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.pointsFor`)}
                </dd>

                {/* points against */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.ladder.pointsAgainst.short`)}:
                </dl>
                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.pointsAgainst`)}
                </dd>

                {/* last five (form) */}
                <dl className="ladder-legend__item ladder-legend__item--key">
                    {getTranslation(`label.form`)}:
                </dl>
                <dd className="ladder-legend__item">
                    {getTranslation(`label.ladder.pastFive`)}
                </dd>
            </dl>
        </aside>
    );
};

LadderLegend.propTypes = {
    qualifiers: PropTypes.number,
    compLabel: PropTypes.string,
    isWinRatio: PropTypes.string
};
